import { render, staticRenderFns } from "./block-organization-invoices.vue?vue&type=template&id=18cde316&scoped=true&lang=pug"
import script from "./block-organization-invoices.vue?vue&type=script&lang=js"
export * from "./block-organization-invoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cde316",
  null
  
)

export default component.exports